import { useEffect, useState } from "react";

const KEY = "mf_playlist";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (ids) => { localStorage.setItem(KEY, JSON.stringify(ids)); window.dispatchEvent(new Event("mf-playlist")); };

// Visitor playlist kept in localStorage (track ids), shared across components via a window event.
export function usePlaylist() {
  const [ids, setIds] = useState(read);
  useEffect(() => { const h = () => setIds(read()); window.addEventListener("mf-playlist", h); return () => window.removeEventListener("mf-playlist", h); }, []);
  return {
    ids,
    has: (id) => ids.includes(id),
    toggle: (id) => write(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id].slice(0, 50)),
    clear: () => write([]),
  };
}
